<template>
	<validation-provider
			:name="'AdminSelectVoucherCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctVchrCd_stateAdminVouchers())"
				item-text="key"
				item-value="key"
				placeholder="Voucher Code"
				@change="$_admnSlctVchrCd_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectVoucherCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctVchrCd_stateAdminVouchers() {
				const self_ = this;
				return () => {
					return self_.getAdminState('vouchers')
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_admnSlctVchrCd_getVouchers()
		},
		methods: {
			$_admnSlctVchrCd_getVouchers() {
				const self_ = this;

				let vouchers_ = self_.getAdminState('vouchers')

				if(!self_.isEmpty(vouchers_)) { return }

				Promise.resolve().then(() => {
					return self_.getFirestoreCollection('vouchers', {}, 0)
				}).then(result => {
					self_.setAdminState('vouchers', result)
				})
			},
			$_admnSlctVchrCd_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				const code_ = input_[self_.inputItemKey]

				if(self_.contentKey == 'updateVoucher') {
					input_.name = self_.adminGetVoucher(code_, 'name')
					input_.point = self_.adminGetVoucher(code_, 'point')
					input_.startDate = self_.formatTimestamp(self_.adminGetVoucher(code_, 'startDate'), 'YYYY-MM-DD')
					input_.endDate = self_.formatTimestamp(self_.adminGetVoucher(code_, 'endDate'), 'YYYY-MM-DD')
					input_.criteriumCode = self_.adminGetVoucher(code_, 'criteriumCode')
					input_.criteriumName = self_.adminGetVoucher(code_, 'criteriumName')
					input_.status = self_.adminGetVoucher(code_, 'status')
				} else {
					input_.voucherName = self_.adminGetVoucher(code_, 'name')
				}
				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
